import React, { useState, useEffect, useMemo } from 'react';
import { UserAuth } from '../../context/AuthContext';
import ReactPaginate from 'react-paginate';
import SearchField from 'react-search-field';
import { RxRocket } from 'react-icons/rx';

export default function GetData({ project }) {
    const [selectedPasukan, setSelectedPasukan] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    const { user, lihatPasukan } = UserAuth();

    const uname = user.displayName;

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const result = await lihatPasukan(uname);
                setData(result);
            } catch (error) {
                setShowNotification(true);
                setError(error.message);
            }
            setLoading(false);
        };

        fetchData();
        const timeoutId = setTimeout(() => setShowNotification(false), 7000);
        setTimeoutId(timeoutId);
    }, [lihatPasukan, uname]);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const filteredData = useMemo(() => {
        return data.filter((item) => {
            return (
                item.telegram.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.twitter.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
    }, [data, searchQuery]);

    const startIndex = currentPage * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
    const itemsToShow = filteredData.slice(startIndex, endIndex);

    // Define a function that returns the value of selectedPasukan

    const [limit, setLimit] = React.useState(50);

    React.useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setLimit(10);
              } else {
                setLimit(23);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return {
        pasukanKu: selectedPasukan,
        htmlElement: (
            <div>
                {loading && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
                        <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
                    </div>
                )}
                {showNotification && (
                    <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
                        <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                            {error}
                            <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
                        </div>
                    </div>
                )}
                <div className='pb-4 leading-3'>
                    <h1 className='text-xl'>Project yang dipilih <span className='font-bold md:font-semibold'>{project}</span></h1>
                    <h2 className='text-sm'>Pilih pasukan untuk mulai menggarap airdrop</h2>
                </div>
                <div className="overflow-x-auto">
                    <table className='w-full items-center text-left table-auto'>
                        <thead className='font-medium text-sm text-zinc-600 border-b border-t'>
                            <tr>
                                <th className='py-2 px-3 w-1/12'>No.</th>
                                <th className='py-2 px-3'>Telegram</th>
                                <th className='py-2 px-3'>Twitter</th>
                                <th className='py-2 px-3 w-2/12 text-center'>Action</th>
                            </tr>
                        </thead>
                        <tbody className='font-normal text-sm text-zinc-600 border-b'>
                            {itemsToShow.map((item, index) => (
                                <tr key={item.id} className='hover:bg-gray-200'>
                                    <td className='py-2 px-3 w-1/12'>{startIndex + index + 1}</td>
                                    <td className='py-2 px-3'>
                                        {item.telegram.length > limit ? (
                                            <span title={item.telegram}>{item.telegram.slice(0, limit)}...</span>
                                        ) : (
                                            <span>{item.telegram}</span>
                                        )}
                                    </td>
                                    <td className='py-2 px-3'>
                                        {item.twitter.length > limit ? (
                                            <span title={item.twitter}>{item.twitter.slice(0, limit)}...</span>
                                        ) : (
                                            <span>{item.twitter}</span>
                                        )}
                                    </td>
                                    <td className='py-2 px-3 w-2/12 text-center'>
                                        <button onClick={() => {
                                            setSelectedPasukan(item.telegram)
                                        }} className="py-1 px-2 border border-sky-500 text-xs font-medium rounded-md flex justify-center items-center">
                                            <RxRocket size='14px' className='text-primary  mr-1' /> Garap
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className='py-2'>

                    <SearchField
                        placeholder="Search..."
                        onChange={(value) => {
                            setSearchQuery(value);
                            setCurrentPage(0);
                        }}
                    />
                </div>
                <div className='text-sm text-zinc-600 mt-4'>
                    Showing {startIndex + 1} to {endIndex} of {filteredData.length} entries
                </div>
                <ReactPaginate
                    previousLabel={
                        <span className="px-4 py-2">
                            &lt;
                        </span>
                    }
                    nextLabel={
                        <span className="px-4 py-2">
                         &gt;
                        </span>
                    }
                    breakLabel='...'
                    pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageChange}
                    containerClassName={'flex justify-center mt-4 text-sm'}
                    activeClassName={'bg-primary text-white px-4 py-2 !important'}
                    pageClassName={'border border-gray-100 px-4 py-2'}
                    breakClassName={'border border-gray-100 px-4 py-2'}
                    previousClassName={'border border-gray-100 px-4 py-2'}
                    nextClassName={'border border-gray-100 px-4 py-2'}
                />
            </div>
        )
    }
}